import {fetchViolationTypes} from '@entities/violations/api';
import api from '@shared/api';

import {
    ContentTemplateSearchResponse,
    DictionarySearchResponse,
    MessageTemplateDto,
    MessageTemplateSearchResponse,
    MessageTemplateUpdatePayload,
    NotificationTemplateDto,
    NotificationTemplateSearchPayload,
    NotificationTemplateSearchResponse,
    NotificationTemplateUpdatePayload,
} from './types';

const NSI_PATH = 'dda-trs-nsi-api/api/v1';
const NOTIFICATIONS_PATH = 'dda-notifications/api/v1';

export const fetchNotificationTemplates = async (payload: NotificationTemplateSearchPayload) =>
    (
        await api.post<NotificationTemplateSearchResponse>(
            `${NOTIFICATIONS_PATH}/notification_template/search`,
            payload,
        )
    ).data;

export const fetchNotificationTemplate = async (id: string) =>
    (await api.get<NotificationTemplateDto>(`${NOTIFICATIONS_PATH}/notification_template/${id}`))
        .data;

export const createNotificationTemplate = async (payload: NotificationTemplateUpdatePayload) =>
    (
        await api.post<NotificationTemplateDto>(
            `${NOTIFICATIONS_PATH}/notification_template/`,
            payload,
        )
    ).data;

export const updateNotificationTemplate = async ({
    id,
    payload,
}: {
    id: string;
    payload: NotificationTemplateUpdatePayload;
}) =>
    (
        await api.put<NotificationTemplateDto>(
            `${NOTIFICATIONS_PATH}/notification_template/${id}`,
            payload,
        )
    ).data;

export const fetchMessageTemplates = async ({
    notificationTemplateId,
    page,
    size,
}: {
    notificationTemplateId: string;
    page: number;
    size: number;
}) =>
    (
        await api.post<MessageTemplateSearchResponse>(
            `${NOTIFICATIONS_PATH}/message_template/search`,
            {
                filter: {
                    type: 'EQ',
                    field: 'notificationTemplate.id',
                    values: [notificationTemplateId],
                },
                sorts: null,
                page: {page, size},
            },
        )
    ).data;

export const fetchMessageTemplate = async (id: string) =>
    (await api.get<MessageTemplateDto>(`${NOTIFICATIONS_PATH}/message_template/${id}`)).data;

export const updateMessageTemplate = async ({
    id,
    payload,
}: {
    id: string;
    payload: MessageTemplateUpdatePayload;
}) =>
    (await api.put<MessageTemplateDto>(`${NOTIFICATIONS_PATH}/message_template/${id}`, payload))
        .data;

export const fetchContentTemplates = async ({
    messageTemplateId,
    page,
    size,
}: {
    messageTemplateId: string;
    page: number;
    size: number;
}) =>
    (
        await api.post<ContentTemplateSearchResponse>(
            `${NOTIFICATIONS_PATH}/content_template/search`,
            {
                filter: {
                    type: 'EQ',
                    field: 'messageTemplate.id',
                    values: [messageTemplateId],
                },
                sorts: null,
                page: {page, size},
            },
        )
    ).data;

export const fetchNotificationKinds = async () =>
    (
        await api.post<DictionarySearchResponse>(
            `${NOTIFICATIONS_PATH}/dict_notification_kind/search`,
            {
                page: {page: 0, size: 10000},
            },
        )
    ).data;

export const fetchActiveStatuses = async () =>
    (
        await api.post<DictionarySearchResponse>(`${NSI_PATH}/dict_active_status/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;

export const fetchLanguages = async () =>
    (
        await api.post<DictionarySearchResponse>(`${NSI_PATH}/dict_language/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;

export const fetchMessageChannels = async () =>
    (
        await api.post<DictionarySearchResponse>(
            `${NOTIFICATIONS_PATH}/dict_message_channel/search`,
            {
                page: {page: 0, size: 10000},
            },
        )
    ).data;

export const fetchContentTypes = async () =>
    (
        await api.post<DictionarySearchResponse>(`${NOTIFICATIONS_PATH}/dict_content_type/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;

export {fetchViolationTypes};
